// extracted by mini-css-extract-plugin
export default {"rating":"PC-z","numberOfStars":"QC-z","count":"RC-z","barGraphSpacing":"SC-z","barGraph":"TC-z"};